<template>
  <div class='photos-box'>
    <img class='photos-img' :src='imageUrl' alt='photo'>
    <div class='photos-info'>
      Uploaddato: {{ attachmentDate(attachment.uploadDate) }} {{ attachmentTime(attachment.uploadDate) }} <br>
      {{ attachment.fileName }}
    </div>
    <div class='photos-add'>
      <v-btn class="mx-2" :ripple='false' fab small color="white" @click="openPreviewDialog">
        <v-icon>mdi-loupe</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="previewDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div>
        <div class='dialog-close'>
          <v-btn class="mx-2" :ripple='false' fab small color="white" @click="closePreviewDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class='fullscreen-img-holder'>
          <img class='fullscreen-img' :src='imageUrl' alt='photo'>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  import methods from '@/utils/methods';
  import api from '@/api/api';

  export default {
    name: 'OverviewXrayPreview',

    props: ['attachment', 'visitItem'],

    data: function () {
      return {
        previewDialog: false
      };
    },

    computed: {
      imageUrl() {
        return api.radiographFileUrl(this.visitItem.id, this.attachment.radiographId) || '';
      }
    },

    methods: {
      attachmentDate: function (date) {
        return methods.getDateFromUtc(date);
      },
      attachmentTime: function (date) {
        return methods.getTimeFromUtc(date);
      },
      openPreviewDialog: function () {
        this.previewDialog = true;
      },
      closePreviewDialog: function () {
        this.previewDialog = false;
      },
      downloadRadiograph: function () {
        methods.downloadURL(api.radiographFileUrl(this.visitItem.id, this.attachment.radiographId));
      },
    }
  };
</script>

<style lang="scss" scoped>
  .photos {
    &-box {
      position: relative;
      width: 260px;
      background: #000;
      border-radius: 16px;
      overflow: hidden;
    }

    &-img {
      display: block;
      width: 100%;
      height: auto;
      border-radius: 16px;
    }

    &-info {
      font-size: 14px;
      padding: 10px;
      color: white;
    }

    &-add {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .dialog-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .fullscreen-img-holder {
    background: black;
    min-height: 100dvh;
    min-width: 100dvw;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fullscreen-img {
    display: block;
    width: 100dvw;
    height: 100dvh;
    object-fit: contain;
  }
</style>
